import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const WhatIsMarketMakingPage = () => {
  return (
    <div className="bg-[#0b0d2a] text-white">
      {/* Hero Section */}
      <HeadersNonAuth />
      <br />
      <br />
      <div
        className="h-[300px] bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage: "url('/headers-landing.png')"
        }}
      >
        <h1 className="text-white text-4xl font-bold">What is Market Making</h1>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-6 py-12 space-y-6 text-lg">
        <p>
          A market maker is typically a large bank or institution which helps to ensure the liquidity of a market
          by offering to both buy and sell securities. As an investor, there are some things you need to know about
          market makers. Here’s how they work, why they’re important to the market, and how they use supply and demand.
        </p>

        <h2 className="text-xl font-bold">The Basics</h2>
        <p>
          A market maker is a trader whose primary job is to create liquidity in the market by <span className="text-blue-500">buying and selling securities</span>.
          Market makers are always ready to buy and sell within the market at a publicly quoted price. Usually, a market maker is a
          brokerage house, large bank, or other institution. However, <span className="text-blue-500">it is possible for individuals and smaller firms to be market makers</span>, as well.
        </p>
        <p>
          As the name suggests, market makers “create the market.” In other words, they create liquidity in the market by being
          readily available to buy and sell securities. This creates liquidity within the market. Most importantly, it helps other
          trades occur smoothly. Without market makers, the market would be relatively illiquid, which would prohibit the ease of trades.
        </p>
        <p>
          Here’s how it works: When you <span className="text-blue-500">sell 5,000 shares of a particular stock</span>, a market maker will purchase it from you at what’s called
          the bid price. Then, they’ll turn around and sell it to a buyer at the ask price. Market makers can then sell these purchased
          securities to broker-dealer firms within their exchange. Keep in mind that when market makers purchase securities, they don’t
          always have a buyer lined up right away.
        </p>

        <h2 className="text-xl font-bold">Why It Matters</h2>
        <p>
          Market makers assure that the market stays liquid, which is important so that other trades can occur. They also are readily
          available to “make the market,” i.e., buy or sell according to a publicly quoted price and create a more liquid market.
        </p>
        <p>
          Supply and demand are also important to market makers. That’s because market makers update prices to reflect current supply
          and demand which, as you know, is always changing. Important to note: Market makers have to constantly update their buying and
          selling prices to reflect the market conditions, i.e., supply and demand.
        </p>
        <p>
          Remember, supply is the amount of something for sale (think a commodity, item, even a service), while demand indicates
          <span className="text-blue-500"> whether a buyer wants to purchase it or not</span>. It’s an important concept not just in economics, but in the financial world, as well.
        </p>
        <p>
          Market makers also help regulate the prices of under or overvalued securities. Since market makers can control the amount of
          a security within the market, and therefore set the prices for these securities based on supply and demand, they can help increase
          the price of an undervalued stock by raising its price or decrease the price of one that’s overvalued by lowering its price.
        </p>
        <p>
          Basically, since they control the amount of stocks within the market, they can adjust the prices based on inventory.
          (Remember, supply and demand.) This helps regulate the market.
        </p>
      </div>
    </div>
  );
};

export default WhatIsMarketMakingPage;
